import { Alert, Collapse, Divider, Space } from 'antd';
import styled from 'styled-components';
import COLOR from '@Src/commons/Colors';

export const StyledStepContainer = styled.div`
  padding: 12px 16px;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  // make only container scrollable
  min-height: calc(100% - 116px);
  max-height: calc(100% - 48px);
  // height: calc(100% - 116px);
  overflow-y: auto;

  padding-right: 10px; // to avoid scrollbar override
`;

type DividerProps = {
  fontWeight?: string;
  texttransform?: string;
};
export const StyledDivider = styled(Divider)`
  &.ant-divider {
    color: ${COLOR.GRAY_7} !important;
    border-top-color: ${COLOR.GRAY_4} !important;
    margin: 0 !important;

    .ant-divider-inner-text {
      font-weight: ${(props: DividerProps) => props.fontWeight || 700};
      font-size: 12px;
      line-height: 20px;
      text-transform: ${(props: DividerProps) =>
        props.texttransform || 'capitalize'};
    }
  }
`;

export const StyledCollapse = styled(Collapse)`
  background: ${COLOR.GRAY_2};
  border-radius: 8px !important;
  border: 0 !important;
  .ant-collapse-item {
    border-bottom: 0 !important;
    .ant-collapse-header {
      padding: 12px 8px !important;
      .ant-collapse-expand-icon {
        color: ${COLOR.GRAY_9};
        width: 16px;
        height: 16px;
      }
      .ant-collapse-header-text {
        color: ${COLOR.GRAY_8};
        text-transform: uppercase;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
      }
    }

    .ant-collapse-content {
      border-top: 0;

      &-box {
        padding: 16px 24px !important;
        background: ${COLOR.GRAY_1};
        border: 1px solid ${COLOR.GRAY_2};
        border-radius: 0px 0px 8px 8px;

        display: flex;
        flex-direction: column;
        gap: 16px;
      }
    }
  }
`;

export const StyledAlert = styled(Alert)`
  border-radius: 8px !important;
  border: 0 !important;
`;
export const StyledFullWidthSpace = styled(Space)`
  margin-top: 16px;
  margin-bottom: 24px;
  width: 100%;
`;
export const StyledAction = styled.div`
  display: flex;
  margin-top: 8px;
  justify-content: end;

  .ant-btn {
    padding: 2px 8px !important;
    border-radius: 4px !important;

    span {
      font-size: 12px;
      line-height: 22px;
    }
  }
`;
